import { useQuery } from 'react-query';

import exerciseQueuesApi, {
  exerciseQueuesApiKeys,
  exerciseQueuesAvailabilityQueryOptions,
} from 'api/rest/exerciseQueues/exerciseQueues';
import { FEATURE_FLAGS } from 'constants/dictionaries/featureFlags';
import { useFeatureFlag } from 'hooks/useFeatureFlags/useFeatureFlags';
import useSubjectStore from 'storages/subject';

export const getOnGoAdditionalText = (
  hasOnGoAccess: boolean,
  onGoAvailability?: { available: boolean } | null,
): string | null => {
  if (!hasOnGoAccess) {
    return 'Pracujemy nad tym';
  }

  if (onGoAvailability && !onGoAvailability.available) {
    return 'Niedostepne dla tego przedmiotu';
  }

  return null;
};

const useOnGoAvailability = () => {
  const hasOnGoAccess = useFeatureFlag(FEATURE_FLAGS.ON_GO);
  const { subject } = useSubjectStore();
  const subjectPk = subject?.pk;
  const isAvailabilityQueryEnabled = hasOnGoAccess && subjectPk != null;

  const { data: onGoAvailability } = useQuery(
    isAvailabilityQueryEnabled ? exerciseQueuesApiKeys.availability(subjectPk) : ['exerciseQueues', 'availability', 'disabled'],
    () => {
      if (subjectPk == null) {
        throw new Error('subjectPk is required');
      }

      return exerciseQueuesApi.getAvailability(subjectPk)();
    },
    {
      enabled: isAvailabilityQueryEnabled,
      ...exerciseQueuesAvailabilityQueryOptions,
    },
  );

  const isOnGoUnavailableForSubject = hasOnGoAccess && Boolean(onGoAvailability && !onGoAvailability.available);
  const onGoAdditionalText = getOnGoAdditionalText(hasOnGoAccess, onGoAvailability);
  const isOnGoDisabled = !hasOnGoAccess || isOnGoUnavailableForSubject;

  return {
    hasOnGoAccess,
    onGoAvailability,
    isOnGoUnavailableForSubject,
    onGoAdditionalText,
    isOnGoDisabled,
  };
};

export default useOnGoAvailability;
